import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { DashboardResponsiveApiModelSparse, DashboardsResponsiveExistingApiModel } from 'src/shared/models/dashboard.model';
import { PermissionsData } from './take-ownership.model';

@Injectable({
    providedIn: 'root'
})
export class TakeOwnershipService {

    constructor(
        private cvApiService: CVApiService,
    ) { }

    async loadInactiveDashboards() {
        try {
            const permissionResponse = await this.cvApiService.get('/api/v1/getLoginUserPermissions');
            const permissions: PermissionsData = permissionResponse.data as PermissionsData;
            if (!permissions.ShowDash) {
                return;
            }
        }
        catch (err) {
            console.error("Unable to determine permission")
            throw err;
        }
        
        try {
            const response = await this.cvApiService.get<DashboardsResponsiveExistingApiModel>('/api/v2/dashboards-inactive');
            if (response.status_code === 200) {
                return response.data.Dashboards;
            } else {
                throw response;
            }
        }
        catch (err) {
            console.error("Failed getting inactive dashboards");
            throw err;
        }
    }

    async takeOwnership(dashboardId: number) {
        try {
            const url = `/api/v2/takeDashboardOwnership/${encodeURIComponent(dashboardId)}`;
            let response = await this.cvApiService.put(url);
            if (response.status_code === 200)
                return response;
            else 
                throw response;
        }
        catch (err) {
            console.error("Failed taking ownership of dashboard");
            throw err;
        }
    }
}
